module.exports = __webpack_public_path__ + "img/Frame 5108.6a14cf87.jpg";